import { useState } from "react";
import { C } from "../../shared/theme";
import { taskWords } from "../../shared/taskWords";
import { linkedTasks } from "./taskLinks";
import { AddItemButton } from "../../shared/AddItemButton";

// The tasks for one dream or fear, under its row or card wherever it shows (Radar, the Dreamboard, Fears), folded as a
// goal bar folds its tasks (Craig, 26 Oct 2026: "add Tasks to Fears and Dreams so that the user can see what they are …
// and quickly add the tasks to Today"). "2 tasks to do ▼" opens its unfinished tasks and "+ Add a task"; one with no
// tasks left to do shows only "+ Add a task", so the next one is one tap. Each button names its dream or fear for
// screen readers. `link` is an entry of TASK_LINKS, `name` the dream's or
// fear's words (for the fold's label), `linkTasks` is { tasks, row(task, field), onAddTask(link, id) }, and `inset` lines it
// up with the words above.
export function LinkedTasks({ link, id, name, linkTasks, inset = 14, style }) {
  const [open, setOpen] = useState(false);
  const all = linkedTasks(linkTasks.tasks, link, id);
  const addTask = () => linkTasks.onAddTask(link, id);
  const label = `Add a task for ${name}`;
  // Nothing left to do (no tasks, or all done) is not a fold.
  if (!all.some(t => !t.done)) return <AddItemButton label={label} onClick={addTask} style={{ padding: `0 ${inset}px`, ...style }} />;
  const words = taskWords(all);
  return (
    <>
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={`${name}: ${words}`}
        style={{ display: "flex", alignItems: "center", gap: 6, minHeight: 44, padding: `0 ${inset}px`, background: "none", border: "none", fontSize: 14, fontWeight: 600, color: C.textMid, cursor: "pointer", fontFamily: "inherit", ...style }}>
        {words}<span aria-hidden="true" style={{ fontSize: 11 }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div style={{ padding: `0 ${inset}px 4px` }}>
          {all.filter(t => !t.done).map(t => linkTasks.row(t, link.field))}
          <AddItemButton label={label} onClick={addTask} />
        </div>
      )}
    </>
  );
}
